var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',[(_vm.show)?_vm._t("default"):_c('div',[_c('b-button',{staticClass:"xl-wide",attrs:{"variant":"outline-primary"},on:{"click":_vm.onAdd}},[_c('b-icon',{attrs:{"icon":"plus-circle-fill"}}),_vm._v("\n      Add\n    ")],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }